import { render, staticRenderFns } from "./OfferXianSheng.vue?vue&type=template&id=bb6934e4"
import script from "./OfferXianSheng.vue?vue&type=script&lang=js"
export * from "./OfferXianSheng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports